export default {
    description : {
        title : 'Описание дома',
        mask  : '{Описание дома: building[description]}'
    }
}